import React, { useEffect, useRef, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FaBell } from "react-icons/fa6";
import { useDispatch, useSelector } from "react-redux";
import {
  selectPendingServiceData,
  selectActiveId,
  setActiveId,
} from "../../redux/slices/pendingService/pendingServiceSlice";
import { useTranslation } from "react-i18next";
import PendingOrdersList from "./PendingOrdersList";

const PendingServices = ({ onOpen }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const wrapperRef = useRef(null);

  const pendingServiceData = useSelector(selectPendingServiceData) || [];
  const activeId = useSelector(selectActiveId);

  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setOpen(false);
        dispatch(setActiveId(null));
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [dispatch]);

  const toggleDropdown = () => {
    setOpen((prev) => {
      const next = !prev;

      if (!prev && onOpen) {
        onOpen();
      }

      return next;
    });

    if (!open && pendingServiceData.length === 1) {
      dispatch(setActiveId(pendingServiceData[0].id));
    }
  };

  return (
    <div className="relative" ref={wrapperRef}>
      {/* 🔔 Bell Button */}
      <button
        onClick={toggleDropdown}
        className="relative p-2 bg-white_bg text-primary
                   flex justify-center items-center
                   h-[43px] w-[43px] rounded-[50px]
                   transition hover:bg-black 
                   dark:bg-black_bg dark:hover:bg-white"
        aria-label="Pending services"
      >
        <FaBell className="h-6 w-6" />

        {pendingServiceData.length > 0 && (
          <span
            className="absolute -top-1 -right-1 min-w-[20px] h-[20px]
                       rounded-full bg-primary text-white text-[10px]
                       flex items-center justify-center border-2
                       border-white_bg dark:border-secondary_black"
          >
            {pendingServiceData.length > 99 ? "99+" : pendingServiceData.length}
          </span>
        )}
      </button>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: -8, scale: 0.98 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: -8, scale: 0.98 }}
            transition={{ duration: 0.2 }}
            className="absolute right-[-4.5em] top-[4em] max-w-[500px] w-[390px] md:max-w-[790px] md:w-[790px]
                       rounded-xl bg-white dark:bg-black
                       shadow-xl border border-gray-200
                       dark:border-gray-700 z-50 overflow-hidden"
          >
            {/* Empty state */}
            {pendingServiceData.length === 0 && (
              <div className="max-w-[380px] w-[390px] md:max-w-[790px] md:w-[790px] p-4 text-center text-gray-500">
                {t("noPendingServices")}
              </div>
            )}

            {/* Content */}
            {pendingServiceData.length > 0 && (
              <PendingOrdersList services={pendingServiceData} />
            )}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default PendingServices;
